import React from 'react';
import { useStaticQuery } from 'gatsby';
import { Link } from 'gatsby';
import Image from 'gatsby-image';

const Header = ({ title }) => {
  const backgroundImage = useStaticQuery(graphql`
    query BackgroundImageQuery {
      avatar: file(absolutePath: { regex: "/header.JPG/" }) {
        childImageSharp {
          fluid {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `);

  // TODO: update this image with a better one
  return (
    <div>
      <Image
        fluid={backgroundImage.avatar.childImageSharp.fluid}
        alt='Bunchodudes-main-image'
        style={{
          marginBottom: 12,
        }}
        imgStyle={
          {
            // borderRadius: `50%`,
          }
        }
      />
      <header>
        {' '}
        <h1
          style={{
            fontSize: 36,
            marginBottom: 12,
            marginTop: 0,
          }}>
          <Link
            style={{
              boxShadow: `none`,
              color: `inherit`,
            }}
            to={`/`}>
            {title}
          </Link>
        </h1>
      </header>
      <span>
        The nonsensical rantings, wisdom, philosophies, and stoke of a bunch of
        dudes.
      </span>
    </div>
  );
};

export default Header;
